import React from "react";

// import { AllVendorWorkingLeads } from "../../../FetchAPI";
import DeshbordBreadcrumb from "../../Breadcrumb/DeshbordBreadcrumb";
import Sidebar from "../../Sidebar";
import LeadWorkingDataTable from "./LeadWorkingDataTable";
import DeshBoardFooter from "../../DeshBoardFooter";
import { useAuth } from "../../../../Store/AuthContext";
import { Helmet } from "react-helmet";

export default function LeadsWorkingView() {
  const { RendomTokenfetch } = useAuth();

  return (
    <>
      <Helmet>
    <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb page1={[{ name: "Work Assigned to Me" }]} />
        <section className="user-dashboard">
          <div className="dashboard-outer">
            {RendomTokenfetch && <LeadWorkingDataTable />}
          </div>
        </section>
        
        <div className="deshboard_footer">
          <DeshBoardFooter />
        </div>
      </div>
    </>
  );
}
